import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Translate from "helpers/Translate";
import TextInputbox from "components/Forms/Elements/Textbox";
import Selectbox from "components/Forms/Elements/Selectbox";
import "./folderPath.scss";

const FolderPath = props => {
  const getMetadata = useSelector(state => state.metadata.getMetadata);
  const [metadata, setMetadata] = useState([]);
  const [folderPath, setFolderPath] = useState(
    getMetadata.data.folder_path_prefix || ""
  );
  const [structureType, setStructureType] = useState(
    getMetadata.data.folder_path_structure || "structureType"
  );
  const [dropdowns, setDropdowns] = useState(
    getMetadata.data.folder_path_dropdowns || {}
  );
  let dropDownsKeys = Object.keys(dropdowns || "");

  const getMappedInputs = inputs => {
    const mappedInputs = inputs.length
      ? inputs.map(({ name, value, label }) => ({
          label: label,
          value: value,
          name: name
        }))
      : [];
    return mappedInputs;
  };

  useEffect(() => {
    const inputs = props?.inputs || [];
    const mappedInputs = getMappedInputs(inputs);
    let options = [
      {
        label: "Doc Type Title",
        name: "Doc Type Title",
        value: props.docTypeTitle
      },
      { label: "Manual Entry", name: "Manual Entry", value: "Manual Entry" }
    ];
    options = [...options, ...mappedInputs];

    setMetadata(options);
  }, [getMetadata, props?.inputs]);

  // send back file renaming data to parent component
  useEffect(() => {
    let folderdetails = {
      folderPathPrefix: folderPath,
      folderPath: getPreviewPath(),
      folderPathDropdowns: dropdowns,
      folderPathStructure: structureType
    };
    props.onchildcomponentsupdate(folderdetails, "folder");
  }, [dropdowns, structureType, folderPath]);

  const getPreviewPath = () => {
    let dropDownValues = dropDownsKeys.map((key, index) => {
      let dropDownValue =
        dropdowns[key].inputvalue ||
        dropdowns[key].value ||
        dropdowns[key].label;
      return dropDownValue + dropdowns[key].pathseperator;
    });
    dropDownValues = dropDownValues.filter(ele => ele);
    if (!dropDownValues.length) {
      return folderPath;
    }
    const path = dropDownValues.toString().replaceAll(",", "");
    return folderPath + "/" + path;
  };

  const handleDropdownAdd = type => {
    setStructureType(type);
    const dropDownsKeysLength = dropDownsKeys.length;
    let pathSeperator = "/";
    let dropDownLabel = "Sub-Folder";
    if (type === "suffix") {
      pathSeperator = "_";
      dropDownLabel = "Sub-Folder Suffix";
    }
    setDropdowns({
      ...dropdowns,
      [`dropdown${dropDownsKeysLength + 1}`]: {
        pathseperator: pathSeperator,
        dropdownlabel: dropDownLabel
      }
    });
  };

  const handleChange = e => {
    setFolderPath(e.target.value);
  };
  const handleDropDowns = (e, dropDownIndex, field) => {
    let defaultlabel = "Doc Type Title";
    let def;
    const inputs = props?.inputs || [];
    const mappedInputs = getMappedInputs(inputs) || [];
    let userInput = mappedInputs.length
      ? mappedInputs.find(ele => ele.value === e.target.value)?.label || ""
      : {};
    const sampleInput = mappedInputs.length
      ? mappedInputs.find(ele => ele.value === e.target.value)?.name || ""
      : {};
    if (e.target.value == props.docTypeTitle) {
      def = true;
      userInput = e.target.value;
    } else if (e.target.value == "Manual Entry") {
      def = false;
      userInput = e.target.value;
    }
    switch (field) {
      case "select": {
        setDropdowns({
          ...dropdowns,
          [`dropdown${dropDownIndex}`]: {
            ...dropdowns[`dropdown${dropDownIndex}`],
            label: def ? defaultlabel : userInput,
            value: e.target.value,
            name: sampleInput,
            order: dropDownIndex
          }
        });
        break;
      }
      case "textBox": {
        setDropdowns({
          ...dropdowns,
          [`dropdown${dropDownIndex}`]: {
            ...dropdowns[`dropdown${dropDownIndex}`],
            label: "Manual Entry",
            inputvalue: e.target.value,
            order: dropDownIndex
          }
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  // handle click event of the Remove button
  const handleFolderRemoveClick = index => {
    let filteredDropdowns = Object.fromEntries(
      Object.entries(dropdowns).filter(([key, value]) => value.order !== index)
    );

    let obj1 = Object.fromEntries(
      Object.entries(filteredDropdowns).filter(
        ([key, value]) => value.order < index
      )
    );
    let obj2 = Object.fromEntries(
      Object.entries(filteredDropdowns).filter(
        ([key, value]) => value.order >= index
      )
    );
    let obj2Keys = Object.keys(obj2);

    obj2Keys.forEach(key => {
      obj2[key].order = obj2[key].order - 1;
    });
    filteredDropdowns = { ...obj1, ...obj2 };
    setDropdowns(filteredDropdowns);
  };

  return (
    <div>
      <h2> {Translate({ id: "design_folder_path" })}</h2>
      {""}
      <div className="fx-center-space-between mb-5">
        <label htmlFor="client_label">
          {Translate({ id: "folder_path_prefix" })}:
        </label>
        <i
          className="fas fa-info-circle mt-5"
          data-tip={Translate({
            id: "custom_folder_path_to_which_files_will_be_uploaded_in_dms"
          })}
        ></i>
      </div>
      <TextInputbox
        id="client_label"
        name="client_label"
        placeholder="c:\scanning\data"
        type="text"
        errorKey={`client_label`}
        fieldValue={folderPath}
        onReturnKey={handleChange}
        onChange={handleChange}
      />

      <div>
        <button
          id="add_sub_folder"
          className="btn btn-default-light my-30"
          onClick={() => {
            handleDropdownAdd("subfolder");
          }}
        >
          <i className="fas fa-plus mr-5"></i>
          {Translate({ id: "add_subfolders" })}
        </button>{" "}
        <button
          id="add_suffix"
          className="btn btn-default-light my-30"
          onClick={() => {
            handleDropdownAdd("suffix");
          }}
        >
          <i className="fas fa-plus mr-5"></i>
          {Translate({ id: "add_suffix" })}
        </button>
      </div>

      <div>
        {dropDownsKeys.map((key, index) => (
          <div key={index} className="dropdowns">
            <p>
              Select {dropdowns?.[`dropdown${index + 1}`]?.dropdownlabel}{" "}
              {index + 1} :{" "}
            </p>

            <Selectbox
              options={metadata}
              id={`select-box_${index + 1}`}
              classes={`designer`}
              errorKey={`select_subfolder_${index + 1}`}
              fieldValue={dropdowns?.[`dropdown${index + 1}`]?.value || ""}
              name={dropdowns?.[`dropdown${index + 1}`]?.name || ""}
              onChange={e =>
                handleDropDowns(
                  e,
                  index + 1,
                  "select",
                  dropdowns?.[`dropdown${index + 1}`]?.label
                )
              }
            />
            {dropdowns?.[`dropdown${index + 1}`]?.label === "Manual Entry" && (
              <TextInputbox
                id={`input_box_folder_${index + 1}`}
                errorKey={`input_error_folder_${index + 1}`}
                classes="designer"
                fieldValue={dropdowns?.[`dropdown${index + 1}`]?.inputvalue}
                onChange={e => handleDropDowns(e, index + 1, "textBox")}
              />
            )}
            {/* <div className="btn-box"> */}
            <button
              className="btn-delete btn-primary cancel"
              onClick={() => handleFolderRemoveClick(index + 1)}
            >
              Remove
            </button>
            {/* </div> */}
          </div>
        ))}
      </div>
      <br />
      <br />

      {/* <!-- Preview Panel --> */}
      <div className="preview-pane">
        <div className="title">
          <h3>{Translate({ id: "preview" })} </h3>
        </div>
        <div className="help">
          {Translate({ id: "this_is_just_a_readonly_preview_section" })}
        </div>
        <div className="my-30">Preview Of Built Out Folder Path : </div>
        <h4>{getPreviewPath()}</h4>
      </div>
    </div>
  );
};

export default FolderPath;
